import { Component } from '@angular/core';

@Component({
    selector: 'app-expired-commission-page',
    templateUrl: './expired-commission-page.component.html',
    styleUrls: ['./expired-commission-page.component.scss'],
    standalone: false
})
export class ExpiredCommissionPageComponent {}
